/*
 * getLinkTargetData(settings)
 * Extracts link data from the settings object.
 * Can handle both individual props and complex settings objects with nested link structures.
 * Returns an object with linkText, linkUrl, linkTitle, and linkType properties.
 */
export function getLinkTargetData(settings) {
  const internalKeys = ['cta_link', 'label_link', 'link'];
  const externalKeys = ['external_cta_link', 'external_link'];

  let linkText = '';
  let linkUrl = '';
  let linkTitle = '';
  let linkType = '';

  // Find internal link
  let internalLinkObj = null;
  const internalText = settings?.cta_text || settings?.text || settings?.label;
  for (const key of internalKeys) {
    if (Array.isArray(settings?.[key]) && settings?.[key]?.length) {
      internalLinkObj = settings[key][0];
      break;
    }
  }

  // Find external link
  let externalLinkObj = null;
  for (const key of externalKeys) {
    if (
      typeof settings?.[key] === 'object' &&
      settings?.[key]?.title &&
      settings?.[key]?.href
    ) {
      externalLinkObj = settings[key];
      break;
    }
  }

  if (internalLinkObj) {
    linkText = internalText || internalLinkObj?.title || '';
    linkUrl = internalLinkObj?.url || '';
    linkTitle = internalLinkObj?.title || linkText;
    linkType = 'internal';
  } else if (externalLinkObj) {
    linkText = internalText || externalLinkObj?.title;
    linkUrl = externalLinkObj?.href;
    linkTitle = externalLinkObj?.title || settings?.label || '';
    linkType = 'external';
  } else {
    console.warn('No valid link found for the button.');
    return null;
  }

  return {
    linkText,
    linkUrl,
    linkTitle,
    linkType
  };
}
